module.exports = __webpack_public_path__ + "img/bfit-mobile.ae45fe82.png";